import React from "react";
import { Link } from "react-router-dom";
import "./DeleteAccountPage.css";

export default function DeleteAccountPage() {
  return (
    <main className="delete-account-page">
      <header className="delete-header">

<Link to="/" className="delete-brand">
  <img
    src="/images/customroam-logo.png"
    alt="Custom Roam"
    className="delete-logo"
  />
  <span className="delete-brand-text">
    CUSTOM ROAM
  </span>
</Link>

<Link to="/" className="delete-home-link">
  Home
</Link>

</header>

<div className="delete-account-card">
        <h1>Delete Your Custom Roam Account</h1>

        <p>
          You can permanently delete your Custom Roam account from the mobile
          app.
        </p>

        <ol>
          <li>Sign in to Custom Roam.</li>
          <li>Open My Profile.</li>
          <li>Open Account Info.</li>
          <li>Select Delete Account.</li>
          <li>Enter your current password.</li>
          <li>Confirm permanent deletion.</li>
        </ol>

        <h2>What will be deleted</h2>

<p>Deleting your Custom Roam account permanently deletes:</p>

<ul>
  <li>Your account and profile information</li>
  <li>Roam Share posts, comments, likes, and uploaded media</li>
  <li>Saved itineraries</li>
  <li>Bucket lists</li>
  <li>Notifications</li>
  <li>Other user-generated content associated with your account</li>
</ul>

<h2>Data that may be retained</h2>

<p>
  We may retain limited information only where required by law or for
  fraud prevention, security, dispute resolution, or other legal
  obligations. Any retained data is kept only for as long as necessary.
</p>

        <h2>Request deletion without the app</h2>

        <p>
          To request deletion without using the app, email:
        </p>

        <p>
          <a href="mailto:support@customroam.com">
            support@customroam.com
          </a>
        </p>

        <p>
          Include the email address associated with your Custom Roam account.
          We may verify account ownership before completing the request.
        </p>
      </div>
    </main>
  );
}